/* eslint-disable react/no-array-index-key -- index is only unique item */
import { Hidden, styled } from '@ori-ui/mui';
import { StaticNavigationNavigationItemDtoLinkType } from '@ori/static-api-client-react';
import type { StaticApplicationsFooterBffNavigationItemDto } from '@ori/static-api-client-react';
import React from 'react';

import { useFooterContext } from '../../hooks';
import { extractFooterNavigationType } from '../../utils';
import { Accordion } from './Accordion';
import { SiteLinkGroup } from './SiteLinkGroup';
import { SiteLinkLinks } from './SiteLinkLinks';

const PREFIX = 'SiteLinks';

const classes = {
  content: `${PREFIX}-content`,
};

const Root = styled('div')(({ theme }) => ({
  width: '100%',
  overflow: 'hidden',

  [`& .${classes.content}`]: {
    display: 'grid',
    gridAutoFlow: 'column',
    gridAutoColumns: 'minmax(150px, 1fr)',
    justifyContent: 'center',
    justifyItems: 'center',
    columnGap: theme.spacing(3),
  },
}));

const isRenderable = (item: StaticApplicationsFooterBffNavigationItemDto) => item.title;

export const SiteLinks: React.FC = () => {
  const { data } = useFooterContext();

  const footer = extractFooterNavigationType(data);
  const footerColumns = footer?.children.filter(
    (x) => x.linkType === StaticNavigationNavigationItemDtoLinkType.FooterColumn,
  );

  return (
    <Root>
      <Hidden smDown>
        <div className={classes.content}>
          {footerColumns?.map(
            (item, index) =>
              isRenderable(item) &&
              index < 3 && (
                <SiteLinkGroup
                  key={`g${index}`}
                  header={item.title ?? ''}
                >
                  <SiteLinkLinks items={item.children} />
                </SiteLinkGroup>
              ),
          )}
        </div>
      </Hidden>
      <Hidden smUp>
        {footerColumns?.map(
          (item, index) =>
            isRenderable(item) &&
            index < 3 && (
              <Accordion
                key={`a${index}`}
                header={item.title ?? ''}
              >
                <SiteLinkLinks items={item.children} />
              </Accordion>
            ),
        )}
      </Hidden>
    </Root>
  );
};
